import { get, post } from "@/services/http/platformServer";
import { PremiumFunctionType } from "@/services/PremiumValidator";

export interface AutoRateSetting {
    content1: string;

    content2: string;

    content3: string;

    enable: boolean;

    shopId: number;

    warning: string;
}

export function getAutoRateSetting(joinedShopIds: number[]) {
    const shopId = joinedShopIds[0];

    return get<AutoRateSetting[]>(shopId, "/auto_rate_setting/list", {
        joinedShopIds: joinedShopIds.join(","),
    });
}

export function updateAutoRateSetting(params: Omit<AutoRateSetting, "warning">) {
    return post<AutoRateSetting[]>(params.shopId, "/auto_rate_setting/update", params, {
        pathPremiumValidator() {
            return {
                shopId: params.shopId,
                type: PremiumFunctionType.AUTO_RATE,
            };
        },
    });
}

export default {
    getAutoRateSetting,
    updateAutoRateSetting,
};
